<template>
  <main>
    <b-container>
      <div class="page-breadcrumb">
        <router-link :to="{ name: 'ProjectIndex' }" class="border-0"
          >
          <i class="fa fa-angle-left" /> Back to home</router-link
        >
      </div>

      <div class="section-header">
        <div>
          <h1 class="heading">Usage Limits</h1>
        </div>

        <div class="actions"></div>
      </div>

      <div class="layoutcard position-relative">
           <div v-if="isLoading" class="loading-overlay">
                <div class="spinner"></div>
            </div>
        <b-row>
          <b-col cols="8" lg="7">
            <b-form class="" @submit.prevent="submit">
                <b-row>
                    <b-col>
                        <h2>General</h2>
                        <hr />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <div :class="{ blurred: isLoading}">
                            <b-form-group id="input-group-name" label="Client Name" label-for="input-37">
                            <b-form-select
                                id="input-37"
                                name="input-37"
                                v-model.trim = "form.clientname"
                                v-validate="{ 
                                    required: true, 
                                    max: 100 }"
                                :options="realmOptions"
                                @change="handleChange"
                                size="lg"
                            ></b-form-select>
                            </b-form-group>
                        </div>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Subscription End-date" label-for="input-38">
                        <b-form-datepicker
                            id="input-38"
                            name="input-38"
                            v-model.trim="form.signupDate"
                            v-validate="{ required: true }"
                            size="lg"
                        ></b-form-datepicker>
                        </b-form-group>
                    </b-col>
                </b-row>
                <!-- <b-row>
                    <b-col cols="12">
                        <b-form-group id="input-group-name" label="Client Logo Url" label-for="input-39">
                        <b-form-input
                            id="input-39"
                            name="input-39"
                            v-model.trim="form.clientLogoUrl"
                            v-validate="{ required: true, max: 10000 }"
                            type="text"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <b-form-group id="input-group-name" label="Client Type" label-for="input-40">
                        <b-form-select
                            id="input-40"
                            name="input-40"
                            v-model.trim="form.clientType"
                            v-validate="{
                                required: true,
                                included: [
                                'limited',
                                'unlimited'
                                ]
                            }"
                            :options="types"
                            size="lg"
                        ></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row> -->
                <b-row>
                    <b-col>
                        <h2>Pools</h2>
                        <hr />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                      <b-form-group label="Dis-Allowed DB Types" v-slot="{ ariaDescribedby }">
                        <b-form-checkbox-group
                          id="poolTypes"
                          name="poolTypes"
                          v-model="form.disAllowedCons"
                          :options="sources"
                          :aria-describedby="ariaDescribedby"
                        ></b-form-checkbox-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <b-form-group id="input-group-name" label="Max Pools(Lifetime)" label-for="input-01">
                        <b-form-input
                            id="input-01"
                            name="input-01"
                            v-model.trim="form.maxAllPools"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <!-- <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Pools(Active)" label-for="input-02">
                        <b-form-input
                            id="input-02"
                            name="input-02"
                            v-model.trim="form.maxActivePools"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col> -->
                </b-row>
                <!-- <b-row>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Pools by Type(Lifetime)" label-for="input-03">
                        <b-form-input
                            id="input-03"
                            name="input-03"
                            v-model.trim="form.maxAllPoolsByType"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Pools by Type(Active)" label-for="input-04">
                        <b-form-input
                            id="input-04"
                            name="input-04"
                            v-model.trim="form.maxActivePoolsByType"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Pools Processing Mins" label-for="input-05">
                        <b-form-input
                            id="input-05"
                            name="input-05"
                            v-model.trim="form.maxAllPoolProcessMins"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Files / Pool" label-for="input-06">
                        <b-form-input
                            id="input-06"
                            name="input-06"
                            v-model.trim="form.maxFilesByPool"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Docs / Pool" label-for="input-07">
                        <b-form-input
                            id="input-07"
                            name="input-07"
                            v-model.trim="form.maxDocsByPool"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Storage(Lifetime)" label-for="input-08">
                        <b-form-input
                            id="input-08"
                            name="input-08"
                            v-model.trim="form.maxAllPoolStorageMb"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Storage(Active)" label-for="input-09">
                        <b-form-input
                            id="input-09"
                            name="input-09"
                            v-model.trim="form.maxActivePoolStorageMb"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Storage / Pool" label-for="input-10">
                        <b-form-input
                            id="input-10"
                            name="input-10"
                            v-model.trim="form.maxSinglePoolStorageMb"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row> -->
                <b-row class="mt-4">
                    <b-col>
                        <h2>Projects</h2>
                        <hr />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Projects (Lifetime)" label-for="input-11">
                        <b-form-input
                            id="input-11"
                            name="input-11"
                            v-model.trim="form.maxAllProjects"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Models (Lifetime)" label-for="input-15">
                        <b-form-input
                            id="input-15"
                            name="input-15"
                            v-model.trim="form.maxAllModelsByProject"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <!-- <b-row>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Models(Lifetime)" label-for="input-13">
                        <b-form-input
                            id="input-13"
                            name="input-13"
                            v-model.trim="form.maxAllModels"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Models(Active)" label-for="input-14">
                        <b-form-input
                            id="input-14"
                            name="input-14"
                            v-model.trim="form.maxActiveModels"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row> -->
                <!-- <b-row>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Models / Project(Lifetime)" label-for="input-15">
                        <b-form-input
                            id="input-15"
                            name="input-15"
                            v-model.trim="form.maxAllModelsByProject"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Models / Project(Active)" label-for="input-16">
                        <b-form-input
                            id="input-16"
                            name="input-16"
                            v-model.trim="form.maxActiveModelsByProject"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row> -->
                <!-- <b-row>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Model Calculations(Lifetime)" label-for="input-17">
                        <b-form-input
                            id="input-17"
                            name="input-17"
                            v-model.trim="form.maxAllModelCalcs"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Model Calc Mins(Lifetime)" label-for="input-18">
                        <b-form-input
                            id="input-18"
                            name="input-18"
                            v-model.trim="form.maxAllModelCalcMins"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Model Calculations(Active)" label-for="input-19">
                        <b-form-input
                            id="input-19"
                            name="input-19"
                            v-model.trim="form.maxActiveModelCalcs"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Model Calc Mins(Active)" label-for="input-20">
                        <b-form-input
                            id="input-20"
                            name="input-20"
                            v-model.trim="form.maxActiveModelCalcMins"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Model Calculations/Project(Lifetime)" label-for="input-21">
                        <b-form-input
                            id="input-21"
                            name="input-21"
                            v-model.trim="form.maxAllModelCalcsByProject"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Model Calc Mins/Project(Lifetime)" label-for="input-22">
                        <b-form-input
                            id="input-22"
                            name="input-22"
                            v-model.trim="form.maxAllModelCalcsByProjectMins"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Model Calculations/Project(Active)" label-for="input-23">
                        <b-form-input
                            id="input-23"
                            name="input-23"
                            v-model.trim="form.maxActiveModelCalcsByProject"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Model Calc Mins/Project(Active)" label-for="input-24">
                        <b-form-input
                            id="input-24"
                            name="input-24"
                            v-model.trim="form.maxActiveModelCalcsByProjectMins"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row class="mt-4">
                    <b-col>
                        <h2>Explore</h2>
                        <hr />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Sessions" label-for="input-25">
                        <b-form-input
                            id="input-25"
                            name="input-25"
                            v-model.trim="form.maxExploreSessions"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Session Mins" label-for="input-26">
                        <b-form-input
                            id="input-26"
                            name="input-26"
                            v-model.trim="form.maxExploreSessionMins"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Sessions/User" label-for="input-27">
                        <b-form-input
                            id="input-27"
                            name="input-27"
                            v-model.trim="form.maxExploreSessionsByUser"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Session Mins/User" label-for="input-28">
                        <b-form-input
                            id="input-28"
                            name="input-28"
                            v-model.trim="form.maxExploreSessionMinsByUser"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Sessions/Project" label-for="input-29">
                        <b-form-input
                            id="input-29"
                            name="input-29"
                            v-model.trim="form.maxExploreSessionsByProject"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Session Mins/Project" label-for="input-30">
                        <b-form-input
                            id="input-30"
                            name="input-30"
                            v-model.trim="form.maxExploreSessionMinsByProject"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Sessions/Model" label-for="input-31">
                        <b-form-input
                            id="input-31"
                            name="input-31"
                            v-model.trim="form.maxExploreSessionsByModel"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Session Mins/Model" label-for="input-32">
                        <b-form-input
                            id="input-32"
                            name="input-32"
                            v-model.trim="form.maxExploreSessionMinsByModel"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row class="mt-4">
                    <b-col>
                        <h2>Filters</h2>
                        <hr />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Filters" label-for="input-33">
                        <b-form-input
                            id="input-33"
                            name="input-33"
                            v-model.trim="form.maxFilters"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Filters/Model" label-for="input-34">
                        <b-form-input
                            id="input-34"
                            name="input-34"
                            v-model.trim="form.maxFiltersByModel"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row> 
                <b-row class="mt-4">
                    <b-col>
                        <h2>Analysis</h2>
                        <hr />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Analysis(Lifetime)" label-for="input-35">
                        <b-form-input
                            id="input-35"
                            name="input-35"
                            v-model.trim="form.maxAnalysis"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group id="input-group-name" label="Max Analysis/Model" label-for="input-36">
                        <b-form-input
                            id="input-36"
                            name="input-36"
                            v-model.trim="form.maxAnalysisByModel"
                            v-validate="{ required: true, max: 10000 }"
                            type="number"
                            size="lg"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>          -->
                <b-row>
                    <b-col class="text-right" cols="12">
                        <div class="form-footer">
                            <b-btn variant="primary" size="lg" @click="migrateSettings">
                            <i class="fa fa-database" /> Migrate Settings
                            </b-btn>
                            <b-btn variant="primary" size="lg" type="submit">
                            <i class="fa fa-download" /> Save
                            </b-btn>
                        </div>
                    </b-col>
                </b-row>
            </b-form>
          </b-col>
          <b-col class="text-center mt-4">
            <div class="sticky-top">
              <b-img
                src="/images/set-limits.svg"
                class="my-2"
                width="180"
                alt="Add pool to model"
                title="Add pool to model"
              ></b-img>
              <p class="my-3 px-4">
                For Unlimited/No Limit, leave it empty!<br/>
                Click the button below to reset to defaults.
              </p>
              <b-btn
                variant="outline-secondary"
                @click.prevent="reset"
              >
                <i class="fa fa-undo" /> Reset Defaults
              </b-btn>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </main>
</template>

<script>
import axios from "axios";
import { mapState, mapActions } from "vuex";
import ApiRequest from "@/helpers/ApiRequest";
import InitAdmin from "../Shared/InitAdmin";
import _ from "lodash";

export default {
  name: "Limits",
  components: {
  },
  extends: InitAdmin,
  data() {
    return {
      realmNames: [],
      hasSelected: false,
      isLoading: false,
      selected: [],
      sources: [
        { value: "derwent", text: "Derwent" },
        { value: "plaintext", text: "Plain text" },
        { value: "pubmed", text: "PubMed" },
        { value: "reddit", text: "Reddit" },
        { value: "scopus", text: "Scopus" },
        { value: "derwentwos", text: "Web of Science (Derwent)" },
        { value: "bbso", text: "BBSO (XLSX)" },
        { value: "cordis", text: "Cordis (XLSX)" },
        { value: "kpmg", text: "KPMG (MD)" },
        { value: "google_patent", text: "Google Patents (XLSX)" },
        { value: "pro_quest", text: "Pro Quest (XLS)" },
        { value: "core", text: "Core Api (Query)" },
        { value: "lens", text: "Lens" },
        { value: "lens_patents", text: "Lens Patents" },
        { value: "clinicaltrial", text: "Clinical Trials" }
      ],
      types: [
        { value: "limited", text: "Limited" },
        { value: "unlimited", text: "UnLimited" }
      ],
      form: {
        clientname: null,
        signupDate: null,
        clientLogoUrl: null,
        clientType: null,
        disAllowedCons: [],
        maxAllPools: null,
        maxActivePools: null,
        maxAllPoolsByType: null,
        maxActivePoolsByType: null,
        maxAllPoolProcessMins: null,
        maxActivePoolProcessMins: null,
        maxFilesByPool: null,
        maxDocsByPool: null,
        maxAllPoolStorageMb: null,
        maxActivePoolStorageMb: null,
        maxSinglePoolStorageMb: null,
        maxAllProjects: null,
        maxActiveProjects: null,
        maxAllModels: null,
        maxActiveModels: null,
        maxAllModelsByProject: null,
        maxActiveModelsByProject: null,
        maxAllModelCalcs: null,
        maxAllModelCalcMins: null,
        maxActiveModelCalcs: null,
        maxActiveModelCalcMins: null,
        maxAllModelCalcsByProject: null,
        maxAllModelCalcsByProjectMins: null,
        maxActiveModelCalcsByProject: null,
        maxActiveModelCalcsByProjectMins: null,
        maxAllUsers: null,
        maxUsersByProject: null,
        maxExploreSessions: null,
        maxExploreSessionMins: null,
        maxExploreSessionsByUser: null,
        maxExploreSessionMinsByUser: null,
        maxExploreSessionsByModel: null,
        maxExploreSessionMinsByModel: null,
        maxExploreSessionsByProject: null,
        maxExploreSessionMinsByProject: null,
        maxFilters: null,
        maxFiltersByModel: null,
        maxFiltersByProject: null,
        maxFilterImports: null,
        maxFilterImportsByModel: null,
        maxFilterImportsByProject: null,
        maxAnalysis: null,
        maxAnalysisByModel: null,
        maxAnalysisByProject: null
      }
    };
  },
  async created(){
    this.listRealmNames();
  },
  computed: {
    ...mapState({
      users: (state) => state.user.users,
      realmSettings: (state) => state.setting.realmSettings
    }),
    adminUser(){
      return _.find(this.users, (user) => user.user_name === "admin");
    },
    realmOptions(){
        const options = this.realmNames.map(name => ({
            text: name,
            value: name
        }));

        if(!this.hasSelected){
            return [
                {text: "Select name", value: null},
                ...options
            ];
        }
        return options;
    }
  },
  mounted() {
    // this.form = JSON.parse(JSON.stringify(this.realmSettings));
  },
  methods: {
    ...mapActions(["saveRealmSettings","loadRealmNames",'fetchRealmData','migrateRealmSettings']),
    listRealmNames(){
        this.loadRealmNames().then(result=>{
            this.realmNames = result.realm_names;
        });
    },
    async handleChange(value){
        if(!value) return;
        this.hasSelected = true;
        this.isLoading = true;
        this.form = null;
        try{
            await this.fetchRealmData(value).then((response)=>{
                this.form = response;
            });
        } catch(e){
            console.error(e)
        } finally {
            this.isLoading = false;
        }
    },
    submit() {
        Object.keys(this.form).forEach(key => {
            if(this.form[key] === ""){
                this.form[key] = null;
            }
        });
        delete this.form['_id'];
        this.saveRealmSettings(this.form).then(() => {
            this.$toasted.show("Realm settings saved successfully", {type: "success"});
        });
    },
    migrateSettings(){
        console.log("Migrate Settings..")
        this.migrateRealmSettings().then(()=>{
            this.$toasted.show("Realm Settings Migrated successfully", {type:"success"});
        });
    },
    reset() {
        this.hasSelected = false;
        this.form = {
            clientname: null,
            signupDate: null,
            clientLogoUrl: null,
            clientType: null,
            disAllowedCons: [],
            maxAllPools: null,
            maxActivePools: null,
            maxAllPoolsByType: null,
            maxActivePoolsByType: null,
            maxAllPoolProcessMins: null,
            maxActivePoolProcessMins: null,
            maxFilesByPool: null,
            maxDocsByPool: null,
            maxAllPoolStorageMb: null,
            maxActivePoolStorageMb: null,
            maxSinglePoolStorageMb: null,
            maxAllProjects: null,
            maxActiveProjects: null,
            maxAllModels: null,
            maxActiveModels: null,
            maxAllModelsByProject: null,
            maxActiveModelsByProject: null,
            maxAllModelCalcs: null,
            maxAllModelCalcMins: null,
            maxActiveModelCalcs: null,
            maxActiveModelCalcMins: null,
            maxAllModelCalcsByProject: null,
            maxAllModelCalcsByProjectMins: null,
            maxActiveModelCalcsByProject: null,
            maxActiveModelCalcsByProjectMins: null,
            maxAllUsers: null,
            maxUsersByProject: null,
            maxExploreSessions: null,
            maxExploreSessionMins: null,
            maxExploreSessionsByUser: null,
            maxExploreSessionMinsByUser: null,
            maxExploreSessionsByModel: null,
            maxExploreSessionMinsByModel: null,
            maxExploreSessionsByProject: null,
            maxExploreSessionMinsByProject: null,
            maxFilters: null,
            maxFiltersByModel: null,
            maxFiltersByProject: null,
            maxFilterImports: null,
            maxFilterImportsByModel: null,
            maxFilterImportsByProject: null,
            maxAnalysis: null,
            maxAnalysisByModel: null,
            maxAnalysisByProject: null
        }

        // this.saveRealmSettings({
        //     clientname: this.form.clientname,
        //     signupDate: null,
        //     clientLogoUrl: null,
        //     clientType: null,
        //     disAllowedCons: [],
        //     maxAllPools: null,
        //     maxActivePools: null,
        //     maxAllPoolsByType: null,
        //     maxActivePoolsByType: null,
        //     maxAllPoolProcessMins: null,
        //     maxActivePoolProcessMins: null,
        //     maxFilesByPool: null,
        //     maxDocsByPool: null,
        //     maxAllPoolStorageMb: null,
        //     maxActivePoolStorageMb: null,
        //     maxSinglePoolStorageMb: null,
        //     maxAllProjects: null,
        //     maxActiveProjects: null,
        //     maxAllModels: null,
        //     maxActiveModels: null,
        //     maxAllModelsByProject: null,
        //     maxActiveModelsByProject: null,
        //     maxAllModelCalcs: null,
        //     maxAllModelCalcMins: null,
        //     maxActiveModelCalcs: null,
        //     maxActiveModelCalcMins: null,
        //     maxAllModelCalcsByProject: null,
        //     maxAllModelCalcsByProjectMins: null,
        //     maxActiveModelCalcsByProject: null,
        //     maxActiveModelCalcsByProjectMins: null,
        //     maxAllUsers: null,
        //     maxUsersByProject: null,
        //     maxExploreSessions: null,
        //     maxExploreSessionMins: null,
        //     maxExploreSessionsByUser: null,
        //     maxExploreSessionMinsByUser: null,
        //     maxExploreSessionsByModel: null,
        //     maxExploreSessionMinsByModel: null,
        //     maxExploreSessionsByProject: null,
        //     maxExploreSessionMinsByProject: null,
        //     maxFilters: null,
        //     maxFiltersByModel: null,
        //     maxFiltersByProject: null,
        //     maxFilterImports: null,
        //     maxFilterImportsByModel: null,
        //     maxFilterImportsByProject: null,
        //     maxAnalysis: null,
        //     maxAnalysisByModel: null,
        //     maxAnalysisByProject: null
        // }).then(() => {
        //     this.$toasted.show("Realm settings set to Defaults successfully", {type: "success"});
        //     console.log(this.realmSettings)
        //     console.log(JSON.parse(JSON.stringify(this.realmSettings)))
        //     this.form = JSON.parse(JSON.stringify(this.realmSettings));
        //     console.log(this.form.signupDate)
        // })
    }
  }
};
</script>
<style scoped>
.layoutcard{
    position: relative;
}
.page-wrapper {
  transition: filter 0.2s ease;
}
/* Blur effect */
.blurred {
  filter: blur(4px);
  pointer-events: none; /* prevent clicks */
}

/* Overlay */
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

/* Simple spinner */
.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #ccc;
  border-top-color: #000;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

</style>